import FullPageLayout from '@/components/productPageComponents/fullPageLayout';
import CollapseListWithImages from '@/components/commonComponents/collapseList';
import { useUserAgentInfo } from '@/context/user-agent';
import { useState } from 'react';
import type { IMultipleFeaturesWithDescAndPic } from '@/utils/const/products/interface';
import ListForMobile from './FlattenCardsForMobile';

interface FullPageCollapseProps {
  data: IMultipleFeaturesWithDescAndPic;
  imageAlign: 'left' | 'right';
  background?: string;
}

const FullPageCollapse = ({
  data,
  imageAlign = 'left',
  background = 'white',
}: FullPageCollapseProps) => {
  const { isMobile } = useUserAgentInfo();
  const [active, setActive] = useState<number>(0);

  const { title, items } = data;
  return (
    <FullPageLayout title={title} background={background}>
      {!isMobile ? (
        <CollapseListWithImages
          list={items}
          active={active}
          setActive={setActive}
          reverse={imageAlign === 'right'}
        />
      ) : (
        <ListForMobile
          list={items}
          backgroundInner={background === 'white' ? '#F5F7FA' : '#FFFFFF'}
        />
      )}
    </FullPageLayout>
  );
};

export default FullPageCollapse;
